export default {
    back:"当前用户无数据，请联系国教院0577-86699031",
    YJSProofOfReading:{
        copysuccess:"Copy Success!",
        copysuccesstext:"Please download in the new open webpage.",
        copyfail:"Copy Fail!",
        copyfailtext:"Please open in a new webpage."
    },
    valiform:{
        welcome:'Welcome to',
        title:"Self-Service Certificate Validation",
        code:"Verification Code",
        valid:"Verify",
        name:"Name(Passport/Resident ID card)",
        jobno:"Student ID/Job ID",
        filename:"File Name",
        creatime:"Creat Time",
        secretcode:"Secret Key",
        download:"Download",
        see:"Preview",
        required:"Required"
    }  
}